<template>
    <div>
        <div
            class="new-top-level-folder"
            style="cursor: pointer;"
            @click="newFolder(null)">
            <font-awesome-icon icon="folder-plus" title="New Folder" class="mr-2"/>
            <span style="font-size: 12px; font-weight: bold;">New Top-level Folder</span>
            <img
                v-if="this.updating"
                src="/assets/img/loading_spinner.gif" style="display: inline; width: 25px;">
        </div>
        <vue-tree-list
            :model="treeData"
            @delete-node="remove"
            @change-name="changeName"
            @drop-before="moveNodeBefore"
            @drop="moveNode">

            <template v-slot:leafNameDisplay="slotProps">
                <span v-if="!slotProps.model.isLeaf" @click="listFolder(slotProps.model)" style="cursor: pointer">{{ slotProps.model.name }}</span>
                <a v-else :href="getLinks(slotProps.model.id)" target="_blank">{{ slotProps.model.name }}</a>
                <div v-if="!slotProps.model.isLeaf" style="display: inline">
                    <label :for="'add-file-' + slotProps.model.name" style="display: inline; cursor: pointer">
                        <font-awesome-icon icon="file-arrow-up" title="New File" class="ml-2"/>
                        <input
                            :id="'add-file-' + slotProps.model.name"
                            type="file"
                            style="display: none;"
                            @input="addFile(slotProps.model)">
                    </label>
                    <div
                        title="New Folder"
                        style="cursor: pointer; display: inline"
                        class="fa fa-folder-plus"
                        @click="newFolder(slotProps.model)">
                        <font-awesome-icon icon="folder-plus" title="New Folder" class="ml-1"/>
                    </div>
                </div>
            </template>
        </vue-tree-list>
        <modal name="add-folder-confirmation-modal" height="auto">
            <v-row>
                <v-col cols="12" class="col-sm-12 pa-2">
                    <v-card>
                        <v-card-text>
                        <v-text-field label="New Folder Name" v-model="newFolderName"></v-text-field>
                        <v-btn @click="addFolder" color="primary" block>Create</v-btn>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </modal>
    </div>
</template>

<script>
import { VueTreeList, Tree, TreeNode} from 'vue-tree-list';
import {Folder} from "@/store/models/household/Folder";
import {Document} from "@/store/models/household/Document";
import { library } from '@fortawesome/fontawesome-svg-core';
import { faFileArrowUp, faFolderPlus } from '@fortawesome/free-solid-svg-icons';

library.add(faFileArrowUp, faFolderPlus);

export default  {
    props: {
        householdId: {
            required: true
        }
    },

    computed: {
        getLinks() {
            return (id) => {
                return this.links[id];
            }
        }
    },

    components: {
        VueTreeList
    },

    data() {
        return {
            treeData: new Tree([]),
            updatingNameOf: null, // 'document' | 'folder',
            listedFolders: [],
            newFolderName: '',
            newFolderParent: null,
            newFolderAncestry: null,
            links: {}, //key is the document id, value is the document link,
            updating: false
        }
    },

    mounted() {
        // Initialize Tree
        this.displayUpdate(Folder.api().fetchHouseholdRootFolders(this.householdId).then(({response}) => {
                let folders = response.data.data;
                folders.forEach((folder) => {
                    this.treeData.addChildren(new TreeNode({
                        name: folder.name,
                        id: folder.id,
                        isLeaf: false,
                        addTreeNodeDisabled: true,
                        addLeafNodeDisabled: true
                    }));
                });
        }));
    },

    methods: {
        addFile(parentNode) {
            let fileInput = document.getElementById('add-file-' + parentNode.name);
            let file = fileInput.files[0];
            let reader = new FileReader();
            reader.readAsBinaryString(file);
            reader.onload = () => {
                this.displayUpdate(Document.post({
                    folder_id: parentNode.id,
                    file_file_name: file.name,
                    file_file_size: file.size,
                    file_content_type: file.type,
                    file_content: btoa(reader.result),
                }).then(({response}) => {
                    parentNode.addChildren(new TreeNode({
                        name: file.name,
                        id: response.data.data.id,
                        isLeaf: true
                    }));
                    this.links= {
                        [response.data.data.id]: response.data.data.link,
                        ...this.links
                    };
                }));
            }
        },

        newFolder(parentNode) {
            this.newFolderName = '';
            this.newFolderAncestry = parentNode;
            this.$modal.show('add-folder-confirmation-modal');
        },

        addFolder() {
            this.displayUpdate(Folder.post({
                name: this.newFolderName,
                household_id: this.householdId,
                ancestry: this.newFolderAncestry?.id
            }).then(({response}) => {
                let parentNode = this.newFolderAncestry ? this.newFolderAncestry : this.treeData;
                parentNode.addChildren(new TreeNode({
                    id: response.data.data.id,
                    name: this.newFolderName,
                    parent_id: this.newFolderAncestry?.id,
                    isLeaf: false,
                    addTreeNodeDisabled: true,
                    addLeafNodeDisabled: true,
                }));
                this.$modal.hide('add-folder-confirmation-modal');
            }));
        },

        remove(node){
            // Remove file
            if (node.isLeaf) {
                this.displayUpdate(Document.remove(node.id).then(() => {
                    node.remove();
                }));
            // Remove folder
            } else {
                if (window.confirm('Are sure you want to delete this folder and all its content?')) {
                    this.displayUpdate(Folder.remove(node.id).then(() => {
                        node.remove();
                    }));
                }
            }
        },

        changeName(data) {
            if (data.eventType === 'blur') {
                if (this.updatingNameOf === 'document') {
                    this.displayUpdate(Document.put(data.id, {
                        file_file_name: data.newName
                    }).then(({response}) => {
                        this.links[response.data.data.id] = response.data.data.link;
                    }));
                    this.updatingNameOf = null;
                } else if (this.updatingNameOf === 'folder') {
                    this.displayUpdate(Folder.put(data.id, {
                        name: data.newName
                    }));
                    this.updatingNameOf = null;
                }
            } else {
                this.updatingNameOf = data.node.isLeaf ? 'document' : 'folder';
            }
        },

        listFolder(parentNode) {
            // Never query folder api more than once
            // @todo add a refresh button for folders
            if (!this.listedFolders.includes(parentNode.id)) {
                this.listedFolders.push(parentNode.id);
            }

            parentNode.children = [];

            // List files
            let p1 = Folder.api().fetchDocuments(parentNode.id).then(({response}) => {
                response.data.data.forEach((document) => {
                    parentNode.addChildren(new TreeNode({
                        name: document.file_file_name,
                        id: document.id,
                        isLeaf: true,
                    }));

                    this.links= {
                        [document.id]: document.link,
                        ...this.links
                    }
                });
            }).finally(() => this.updating = false);

            // List folders
            let p2 = Folder.api().fetchSubFolders(parentNode.id).then(({response}) => {
                response.data.data.forEach((folder) => {
                    parentNode.addChildren(new TreeNode({
                        name: folder.name,
                        id: folder.id,
                        isLeaf: false,
                        addTreeNodeDisabled: true,
                        addLeafNodeDisabled: true,
                    }));
                });
            });

            this.displayUpdate(Promise.all([p1, p2]));
        },

        moveNode({node, target}) {
            if (target.isLeaf || node.id === target.id || node.parent_id === target.id) {
                return;
            }


            if (node.isLeaf) {
                this.displayUpdate(Document.put(node.id, {
                    folder_id: target.id
                }).then(({response}) => {
                    this.links[response.data.data.id] = response.data.data.link;
                }));
            } else {
                this.displayUpdate(Folder.put(node.id, {
                    ancestry: target.id
                }));
            }

            // If a folder hasn't been open just drop it in and remove it on the frontend
            // and let clicking on the target folder to show the file.
            if (!this.listedFolders.includes(node.pid)) {
                node.remove();
            }
        },

        moveNodeBefore({node, src, target}) {
            if (node.pid === src.id || (node.isLeaf && node.pid === 0)) {
                return;
            }

            if (node.isLeaf) {
                this.displayUpdate(Document.put(node.id, {
                    folder_id: target.pid
                }).then(({response}) => {
                    this.links[response.data.data.id] = response.data.data.link;
                }));
            } else {
                this.displayUpdate(Folder.put(node.id, {
                    ancestry: target.pid === 0 ? null : target.pid
                }));
            }
        },

        displayUpdate(promise) {
            this.updating = true;
            promise.finally(() => this.updating = false);
        }
    }
}
</script>
